import { computed } from 'vue';
import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { Session } from '/@common/utils/storage';
import qs from 'qs';
import { storeToRefs } from 'pinia';
import { useUserInfo } from '/@/stores/userInfo';
import { useThemeConfig } from '/@/stores/themeConfig';
import { useChatStore } from '/@/stores/chat';
import { useRoleConfig } from '/@/stores/role';
import { toTraditional } from '/@common/components/chinese-simple2traditional/dist';
import { setupEnhance } from '/@common/components/chinese-simple2traditional/dist/enhance';
import { Message } from 'winbox-ui-next';
import * as Sentry from '@sentry/vue';
import { useRouter } from 'vue-router';
import { useBasicLayout } from '/@common/hooks/useBasicLayout';
import {getGuestId,getTicketId} from "/@common/utils/utils.ts"
import DSBridge from '/@common/utils/dsBridge/dsBridge'; 
const { isMobile } = useBasicLayout();
const chatStore = useChatStore();
const roleConfig = useRoleConfig();
const router = useRouter();

if (import.meta.env.VITE_APP_NAME !== 'chath5' && import.meta.env.VITE_APP_NAME !== 'chatapp') {
	setupEnhance(); // 注入短语库
}

// 配置新建一个 axios 实例
const service: AxiosInstance = axios.create({
	baseURL: import.meta.env.VITE_API_URL,
	timeout: 1000 * 60 * 3,
	headers: { 'Content-Type': 'application/json' },
	paramsSerializer: {
		serialize(params) {
			return qs.stringify(params, { allowDots: true });
		},
	},
});

// 添加请求拦截器
service.interceptors.request.use(
	(config: AxiosRequestConfig) => {
		// 在发送请求之前做些什么 token
		const storesThemeConfig = useThemeConfig();
		const { themeConfig } = storeToRefs(storesThemeConfig);
		let ticket =getTicketId()? getTicketId():'';
		let Platform=isMobile.value ? 'h5':'pc';
		if(DSBridge.isDSBridgeEnvironment()){
			Platform='app'
		}
		if (Session.get('token')) {
			config.headers!['Authorization'] = `${Session.get('token')}`;
			config.headers!['token'] = `${Session.get('token')}`;
		}
		if(ticket){
			config.headers!['GuestId'] = getGuestId();
			config.headers!['Ticket'] = ticket;
		}
		config.headers!['I18n'] = themeConfig.value.globalI18n;
		config.headers!['Platform'] = Platform
		if(import.meta.env.VITE_APP_NAME === 'chat'&&(config.url?.includes('/api/sso/auth/weiXinBindPhoneNumber')||config.url?.includes('/api/sms/send'))){//login在admin中 特殊处理
			config.baseURL='/admin'
		}
		if(import.meta.env.VITE_APP_NAME === 'admin'&&(config.url?.includes('/api/chatLogin/login'))){
			config.baseURL='/chat'
		}
		return config;
	},
	(error) => {
		// 对请求错误做些什么
		return Promise.reject(error);
	}
);

// 添加响应拦截器
service.interceptors.response.use(
	(response) => {
		let data = response.data;
		if(DSBridge.isDSBridgeEnvironment()&&(data?.code === 401 || data?.msg === 4001)){
		    Message.info({
				id: 'logoutMessageInfo',
				content:'登录已过期',
			})
			return
		}
		if (import.meta.env.VITE_APP_NAME === 'chat') {
			if (data.code != '200') {
				Sentry.captureException(response, (scope) => {
					scope.setContext('message', {
						userInfos: Session.get('userInfo'),
						url: response?.config?.baseURL + response?.config?.url,
						data: JSON.stringify(response?.config?.data),
						method: response?.config?.method,
						status: response?.status,
						statusText: response?.statusText,
						responseData: JSON.stringify(response?.data),
					});
					scope.setTag('title', '请求异常');
					return scope;
				});
			}
		}
		
		const storesThemeConfig = useThemeConfig();
		const { themeConfig } = storeToRefs(storesThemeConfig);
		if (!response.config.responseType) {
			try {
				if (themeConfig.value.globalI18n == 'zh-HK') {
					data = JSON.parse(toTraditional(JSON.stringify(data), true));
				}
			} catch (error) {}
		}

		return data;
	},
	(error) => {
		const res = error.response?.data;
		const stores = useUserInfo();	
		if (error.code === 'ERR_NETWORK') {
			console.log('网络连接似乎有点问题，检查您的网络设置后再次尝试。');
			Message.error({
				id: 'ERR_NETWORK',
				content: `网络连接似乎有点问题，检查您的网络设置后再次尝试。`,
			});
			return;
		}
		if (error.code === 'ECONNABORTED') {
			return Promise.reject(error);
		}
		if(res?.code === 401 || res?.msg === 4001){
			if(DSBridge.isDSBridgeEnvironment()){
			    Message.info({
					id: 'logoutMessageInfo',
					content:'登录已过期',
				})
				return
			}
			if(getTicketId()){
				return
			}
			if(import.meta.env.VITE_APP_NAME === 'chat'&&Session.get('phoneNumber')!='bind'){
				console.log("401")
				router.push({ path: '/chat/21' });
				roleConfig.setCurrentRole('1658297003183144963');
				chatStore.isOpen=false
				stores.clearLoginMessage()
				stores.loginUrl ='/admin/'
				stores.isLoginState = false;
				return
			}else{
				stores.clearLoginMessage()
				window.location.reload();
				return
			}
			
		}
		if (error.code === 'ERR_BAD_REQUEST') {
			// Message.error({
			// 	id: 'ERR_BAD_REQUEST',
			// 	content: `存在安全问题`,
			// });
			return
		}
		if (!axios.isCancel(error)) {
			if (res.code === 401 || res.msg === 4001) {
				stores.userInfos.isLoginExpired = true;
				stores.isLoginState = true;
				return;
			}
		}
		return Promise.reject(error);
	}
);

// 导出 axios 实例
export default service;
